import type {Template} from '@helpers/select-template';

import {chooseAndCloneTemplate} from '@helpers/select-template';

import {
  DEFAULT_MOBILE_FLUTTY_TEMPLATE_PROJECT_NAME,
  DEFAULT_MOBILE_MIREGMA_TEMPLATE_PROJECT_NAME,
  MOBILE_FLUTTY_TEMPLATE_REPO,
  MOBILE_MIREGMA_TEMPLATE_REPO
} from '../constants/templates';

export const initMobile = async (): Promise<void> => {
  const templates: Template[] = [
    {name: DEFAULT_MOBILE_FLUTTY_TEMPLATE_PROJECT_NAME, repo: MOBILE_FLUTTY_TEMPLATE_REPO},
    {name: DEFAULT_MOBILE_MIREGMA_TEMPLATE_PROJECT_NAME, repo: MOBILE_MIREGMA_TEMPLATE_REPO}
  ];

  await chooseAndCloneTemplate(templates);
};
